import { UserStatus } from '../types/enums/UserStatus.enum.ts';

export type UserStatusStyle = {
  name: string;
  color: string;
  backgroundColor: string;
};

const STATUS_STYLES: Record<number, UserStatusStyle> = {
  [UserStatus.UNDEFINED]: { name: 'Undefined', color: '#475569', backgroundColor: '#edf2f7' },
  [UserStatus.ACTIVE]: { name: 'Active', color: '#2f855a', backgroundColor: '#c6f6d5' },
  [UserStatus.INACTIVE]: { name: 'Inactive', color: '#475569', backgroundColor: '#edf2f7' },
  [UserStatus.PENDING]: { name: 'Pending', color: '#b7791f', backgroundColor: '#fefcbf' },
};

export const getUserStatusStyle = (statusId: number): UserStatusStyle => STATUS_STYLES[statusId];
